module.exports = __webpack_public_path__ + "media/images/salon-27d3b828a6200bc8690ee8888bc2bd4f.jpg";